export default {
    state:{
        list:[],
        searchtext:''
    },
    mutations:{
        SET_HISTORY_LIST(state:any,val:any){
            state.list=val
            // state.list=[...state.list,val]
        },
        CHANGE_SEARCH_TEXT(state:any,val:any){
            state.searchtext=val
        }
    },
    actions:{
    },
    namespaced:true//模块化命名

}